import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import productsphoto from "../images/about photo.jpg";
import ScrollToTop from "react-scroll-to-top";

function About() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
  <ScrollToTop smooth top="100" color="#081750"/>
            <div className='AMYPEPPlussyrup'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">About us <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">
                            <div className="card-body">
                                <h2 style={{color:'#021b66'}}><b>WELCOME TO ARISTACURE BIOTECH PRIVATE LIMITED</b></h2>
                                <h6 style={{color:"#472714"}} className='syrup'>Aristacure Biotech Pvt. Ltd. is a fast-growing pharmaceutical and nutraceutical company committed to delivering high-quality, affordable healthcare solutions. With a focus on innovation, safety, and patient wellness, we offer a diverse range of products including syrups, capsules, drops, and tablets—designed for all age groups. Driven by science and guided by ethics, Aristacure is dedicated to improving lives through trusted and effective formulations.</h6>
                                <h6 style={{color:"#472714"}} className='syrup'>With a product portfolio that spans syrups, capsules, tablets, and drops, we address a wide spectrum of therapeutic areas, including pediatrics, general wellness, gastroenterology, respiratory care, and nutritional deficiencies. Our formulations are developed using cutting-edge research, stringent quality control processes, and a deep understanding of patient needs.</h6>
                                <h6 style={{color:"#472714"}} className='syrup'>Our mission is grounded in science, ethics, and compassion, with a vision to become a leading name in both domestic and international markets. As we continue to grow, Aristacure remains steadfast in its commitment to improving lives through trusted, high-quality formulations that truly make a difference.</h6>
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
  <img src={productsphoto} className="card-img-top" alt="productsphoto"/>

                        </div>
                    </div>
                </div>
            </div>
            <br />

        </div>
    )
}

export default About